import React, { useEffect, useState } from "react";
import Loader from "../components/Loader";
import { useHistory } from "react-router-dom";
// eslint-disable-next-line
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import ContainerHome from "../components/ContainerHome";
import { Button } from "react-bootstrap";

const DocumentsScreen = () => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  let history = useHistory();

  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(false);

  const handleClick = () => {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");
    history.push("/login");
  };

  useEffect(() => {
    // eslint-disable-next-line
    if (userInfo.statusDoc == 2) {
      setStatus(true);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <ToastContainer />

      {loading ? (
        <Loader />
      ) : (
        <>
          
          {status === false ? (
            <>
              <ContainerHome>
                <div className="card o-hidden border-0 shadow-lg my-5">
                  <div className="card-body p-0">
                    <div className="row text-center">
                      <img
                        src="img/aguarde.png"
                        className="img-fluid"
                        width="100%"
                        height="90%"
                        alt="aguarde"
                      />

                      <Button
                        className="btn btn-warning btn-lg mt-3 mb-3"
                        onClick={handleClick}
                      >
                        <i className="fas fa-angle-left"></i> Clique aqui para
                        Retornar
                      </Button>
                    </div>
                  </div>
                </div>
              </ContainerHome>
            </>
          ) : (
            <>
            
             {window.location.href = "/credencial"} 
            
            </>
          )}
        </>
      )}
    </>
  );
};

export default DocumentsScreen;
